<template>
  <div class="nettdoc-truefalse">
    <div>
      <label class="nettdoc-truefalse__radio">
          <input :name="'radio_'+randomId" type="radio" value="yes" v-model="storeModel" 
            @change="e => $emit('action', e.target.value)"
          />
          <span class="nettdoc-checkmark"></span>
          <span class="nettdoc-radiotext">{{ $t('Yes') }}</span>
      </label>

      <label class="nettdoc-truefalse__radio">
          <input :name="'radio_'+randomId" type="radio" value="no" v-model="storeModel" 
            @change="e => $emit('action', e.target.value)"
          />
          <span class="nettdoc-checkmark"></span>
          <span class="nettdoc-radiotext">{{ $t('No') }}</span>
      </label>
    </div>
      <p v-if="infoText1 && infoText1.length > 0 && storeModel === 'yes'" class="nettdoc-truefalse__infotext">
              {{ $t(infoText1) }}
          </p>
      <p v-if="infoText1 && infoText1.length > 0 && storeModel === 'no'" class="nettdoc-truefalse__infotext">
          {{ $t(infoText2) }}
      </p>
  </div>
</template>

<script>
export default {
  name: 'YesNo',
  data() {
    return {
      storeModel: this.model,
      randomId: Math.random(10)
    }
  },
  props: {
    infoText1: String,
    infoText2: String,
    model: String
  }
}
</script>

<style lang="scss" scoped>
  .nettdoc-truefalse {
    box-sizing: border-box;
    position: relative;
    padding: 0 16px;
    padding-bottom: 15px;
    div {
      display: grid;
      grid-template-columns: 50% 50%;
    }
    &__radio {
      float:left;
      display: block;
      box-sizing: border-box;
      height: 45px;
      position: relative;
      padding-left: 35px;
      padding-top: 22px;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      color: var(--cool-grey);
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        &:checked {
          ~ .nettdoc-checkmark {
              background: url(../assets/control-radio-check.svg);
          }
          ~ .nettdoc-radiotext {
              color: var(--charcoal-grey) !important;
          }
        }
      }
      .nettdoc-checkmark {
        position: absolute;
        top: 18px;
        left: 0;
        height: 24px;
        width: 24px;
        background: url(../assets/control-radio-null.svg);
        border-radius: 50%;
      }
    }

    &__infotext {
        margin: unset;
        color: var(--dark-peach);
        font-size: 12px;
        font-weight: 600;
        padding-left: 35px;
        text-align: left;
    }

    input {
      margin: 0 10px;
    }
  }
</style>